import React, { useState, useEffect, useRef } from 'react';
import '../../assets/css/botompanel.css';
import { Link } from 'react-router-dom';

function BottomPanel({ wishlistCount = 0, cartCount = 0 }) {
  const [activeTab, setActiveTab] = useState('home');
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  const accountRef = useRef(null);
  const navItems = [
    { key: 'home', label: 'Home', icon: 'bi-house', fillIcon: 'bi-house-fill' },
    { key: 'category', label: 'Category', icon: 'bi-grid', fillIcon: 'bi-grid-fill' },
    { key: 'Wishlist', label: 'Wishlist', icon: 'bi-heart', fillIcon: 'bi-heart-fill', count: wishlistCount, path: '/wishlist' },
    { key: 'Cart', label: 'Cart', icon: 'bi-cart', fillIcon: 'bi-cart-fill', count: cartCount, path: '/checkout/cart' },
    { key: 'account', label: 'My Account', icon: 'bi-person', fillIcon: 'bi-person-fill' },
  ];
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        setAccountMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleTabClick = (key) => {
    setActiveTab(key);
    setAccountMenuOpen(key === 'account' ? (prev) => !prev : false);
  };
  
  return (
   <> 
   <div className="bottom-panel fixed bottom-0 w-full bg-white shadow-lg z-50">
      <ul className="flex justify-around items-center relative">
        {navItems.map((item) => (
           <li
            key={item.key}
            className={`bottom-nav-item text-center relative ${activeTab === item.key ? 'text-blue-600' : 'text-gray-500'}`}
            onClick={() => handleTabClick(item.key)}
            ref={item.key === 'account' ? accountRef : null}
            >
            <Link to={item.path} className="flex flex-col items-center relative">
              <div className="icon mb-1 relative">
                <i className={`bi ${activeTab === item.key ? item.fillIcon : item.icon} text-lg`}></i>
                {'count' in item && (
                  <span className="absolute -top-1 -right-2 bg-red-500 text-white text-[10px] font-bold rounded-full px-1.5 py-0.5">
                    {item.count}
                  </span>
                )}
              </div>
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
            {item.key === 'account' && accountMenuOpen && (
              <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-white border rounded-lg shadow-lg w-36 text-sm z-10" style={{ marginLeft: "-19px" }}>
                <ul className="flex flex-col py-1">
                  <li>
                    <Link to="/signin" className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100">
                      <i className="bi bi-box-arrow-in-right"></i>
                      <span>Sign In</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/profile" className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100">
                      <i className="bi bi-people"></i>
                      <span>My Profile</span>
                    </Link>
                  </li>
                </ul>
              </div>
              )}
          </li>
        ))}
      </ul>
    </div>
   </>
  );
}
export default BottomPanel;